var chunkMapping = {
	"1808": [
		91808
	],
	"3245": [
		15907,
		21949,
		30069,
		42898,
		49571,
		50813,
		51616,
		58982,
		63637,
		75302,
		78265,
		84876,
		86221,
		93383,
		96513
	],
	"7722": [
		37722
	]
};
var idToExternalAndNameMapping = {
	"15907": [
		"default",
		"./middleware",
		14416
	],
	"21949": [
		"default",
		"./pages",
		5968
	],
	"30069": [
		"default",
		"./pages",
		56938
	],
	"37722": [
		"default",
		"./pages",
		51482
	],
	"42898": [
		"default",
		"./pages",
		93075
	],
	"49571": [
		"default",
		"./theme",
		14416
	],
	"50813": [
		"default",
		"./pages",
		79403
	],
	"51616": [
		"default",
		"./entities",
		34467
	],
	"58982": [
		"default",
		"./widgets",
		57962
	],
	"63637": [
		"default",
		"./pages",
		43741
	],
	"75302": [
		"default",
		"./pages",
		12477
	],
	"78265": [
		"default",
		"./pages",
		91222
	],
	"84876": [
		"default",
		"./app-settings",
		14416
	],
	"86221": [
		"default",
		"./pages",
		76972
	],
	"91808": [
		"default",
		"./pages",
		20153
	],
	"93383": [
		"default",
		"./pages",
		42690
	],
	"96513": [
		"default",
		"./pages",
		31420
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}